var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardCoinTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.4207 0.10498C77.4662 0.10498 99.5944 22.44 99.5944 49.7383C99.5944 77.0366 77.4662 99.3715 50.4207 99.3715C23.3751 99.3715 1.24695 77.0366 1.24695 49.7383C1.24695 22.44 23.3751 0.10498 50.4207 0.10498Z",
    fill: "url(#paint0_radial_153_1779)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7742 33.9227C73.8267 33.9757 73.876 34.0311 73.9218 34.0886C75.7993 36.154 75.7469 39.3686 73.7643 41.3696L48.4096 66.9613C46.3731 69.0168 43.0681 69.0168 41.0316 66.9613L28.3542 54.1655C26.3178 52.11 26.3178 48.7741 28.3542 46.7186C30.3905 44.6633 33.695 44.6631 35.7315 46.7179L44.7252 55.787L66.3963 33.9227C68.4327 31.8672 71.7378 31.8672 73.7742 33.9227Z",
    fill: "url(#paint1_radial_153_1779)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7702 50.8748C26.262 52.6729 26.7089 54.6888 28.1111 56.104L40.9242 69.0369C42.9825 71.1144 46.3229 71.1144 48.3812 69.0369L74.0075 43.1711C75.4031 41.7625 75.8524 39.7589 75.3555 37.9672C75.1963 39.0513 74.7037 40.0949 73.8774 40.9289L48.3963 66.6482C46.3497 68.7139 43.0281 68.7139 40.9815 66.6482L28.241 53.7885C27.4269 52.9669 26.9367 51.9416 26.7702 50.8748Z",
    fill: "url(#paint2_linear_153_1779)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9218 34.0886C73.8759 34.0311 73.8267 33.9757 73.7742 33.9227C71.7378 31.8672 68.4327 31.8672 66.3963 33.9227L44.7252 55.787L35.7315 46.7179C33.695 44.6631 30.3905 44.6633 28.3542 46.7186C27.1122 47.9723 26.6276 49.7023 26.9007 51.3276C27.0754 50.2882 27.5599 49.2916 28.3542 48.4898C30.3905 46.4345 33.695 46.4343 35.7315 48.4891L44.7252 57.5582L66.3963 35.6939C68.4327 33.6384 71.7378 33.6384 73.7742 35.6939C73.8267 35.7469 73.8759 35.8023 73.9218 35.8598C74.623 36.6312 75.055 37.5629 75.2178 38.5318C75.4791 36.977 75.0471 35.3264 73.9218 34.0886Z",
    fill: "url(#paint3_linear_153_1779)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4207 4.27417C76.6466 4.27417 98.365 25.537 99.5944 52.2198C99.5944 51.386 99.5944 50.5521 99.5944 50.1352C99.5944 22.6186 77.4662 0.10498 50.4207 0.10498C23.3751 0.10498 1.24695 22.2017 1.24695 49.7183C1.24695 50.5521 1.24695 51.386 1.24695 51.8029C2.47629 25.537 24.1947 4.27417 50.4207 4.27417Z",
    fill: "url(#paint4_linear_153_1779)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0973 95.72C75.0412 95.72 95.2622 75.3101 95.2622 50.1331C95.2622 24.9561 75.0412 4.54614 50.0973 4.54614C25.1535 4.54614 4.9325 24.9561 4.9325 50.1331C4.9325 75.3101 25.1535 95.72 50.0973 95.72ZM50.195 94.387C74.0622 94.387 93.4103 74.858 93.4103 50.7678C93.4103 26.6776 74.0622 7.14858 50.195 7.14858C26.3279 7.14858 6.9797 26.6776 6.9797 50.7678C6.9797 74.858 26.3279 94.387 50.195 94.387Z",
    fill: "url(#paint5_linear_153_1779)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6096 72.8384C17.8458 84.3397 30.0919 92.4564 44.5724 93.8137C69.4044 96.1411 91.404 77.7094 93.7099 52.6454C94.6152 42.8047 92.3501 33.4046 87.7617 25.4753C93.0773 33.7632 95.776 43.846 94.8014 54.4395C92.495 79.5086 70.491 97.944 45.654 95.616C30.427 94.1888 17.6702 85.2888 10.6096 72.8384Z",
    fill: "url(#paint6_linear_153_1779)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_153_1779",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4082 0.104981) rotate(84.9714) scale(102.819 88.6607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397268,
    stopColor: "#F4E48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613719,
    stopColor: "#EFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91342,
    stopColor: "#713E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#C89B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_153_1779",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7731 36.4108) rotate(64.9782) scale(35.4161 45.8793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#E0A100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615734,
    stopColor: "#754600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#371F09"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_153_1779",
    x1: 25.158,
    y1: 52.1018,
    x2: 77.8065,
    y2: 36.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFF0C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_153_1779",
    x1: 51.7221,
    y1: 31.1059,
    x2: 51.3575,
    y2: 57.0663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B1C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B1C00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_153_1779",
    x1: 50.4207,
    y1: 0.10498,
    x2: 50.4207,
    y2: 52.2198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_153_1779",
    x1: 26.3706,
    y1: 109.889,
    x2: 109.752,
    y2: 45.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#642700",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111955,
    stopColor: "#653100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824903,
    stopColor: "#653100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#642700",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_153_1779",
    x1: 94.4189,
    y1: 44.6108,
    x2: 16.7108,
    y2: 82.5262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD85D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261997,
    stopColor: "#FAD85D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.420095,
    stopColor: "#FEFDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601442,
    stopColor: "#F8D55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D55A",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardCoinTick);
export default __webpack_public_path__ + "static/media/reward-coin-tick.d523df83688fb54d4e4250645653d92a.svg";
export { ForwardRef as ReactComponent };